import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import GettingStarted from './pages/GettingStarted';
import Chat from './pages/Chat';
import Projects from './pages/Projects';
import CodeEditor from './pages/CodeEditor';
import Visualisation from './pages/Visualisation';
import CloudAnalyzer from './pages/CloudAnalyzer';
import Integrations from './pages/Integrations';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<GettingStarted />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/code-editor" element={<CodeEditor />} />
          <Route path="/visualisation" element={<Visualisation />} />
          <Route path="/cloud-analyzer" element={<CloudAnalyzer />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="*" element={<GettingStarted />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
